
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import LoginForm from './LoginForm';
import { useLanguage } from '@/contexts/LanguageContext';

interface AuthCardProps {
  onSuccessfulAuth: (isAdmin: boolean) => void;
}

const AuthCard: React.FC<AuthCardProps> = ({ onSuccessfulAuth }) => {
  const { t } = useLanguage();

  return (
    <Card className="w-full max-w-md mx-auto bg-brand-gray border-none">
      <CardHeader className="text-center">
        <CardTitle className="text-2xl font-bold text-white">
          DartsBeat Shop
        </CardTitle>
        <CardDescription className="text-gray-400">
          {t('auth.enterWithDartsBeat') || 'Entre com a sua conta DartsBeat'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <LoginForm onSuccessfulAuth={onSuccessfulAuth} />
      </CardContent>
    </Card>
  );
};

export default AuthCard;
